// src/routes/index.jsx
import React from "react";
import { Routes } from "react-router-dom";
import MainRoutes from "./MainRoutes";
import AuthRoutes from "./AuthRoutes";

const AppRoutes = () => (
  <Routes>
    {MainRoutes}
    {AuthRoutes}
  </Routes>
);

export default AppRoutes;
